<div class="d-flex">
  <div class="row" (keydown.enter)="update()">
    <div class="col-9">
      <div class="form-row">
        <div class="form-group col">
          <app-consolidation-filter [placeholder]="'Search Master BL/AWB#'" (inputChange)="onFilterInputChange($event, columns.MasterBillNumber)"></app-consolidation-filter>
        </div>
        <div class="form-group col">
          <app-consolidation-filter [placeholder]="'Search House B/L#'" (inputChange)="onFilterInputChange($event, columns.HouseBillNumber)"></app-consolidation-filter>
        </div>
        <div class="form-group col">
          <app-consolidation-filter [placeholder]="'Search Container#'" (inputChange)="onFilterInputChange($event, columns.ContainerNumber)"></app-consolidation-filter>
        </div>
        <div class="form-group col">
          <app-consolidation-filter [placeholder]="'Search Order/Ref/INV#'" (inputChange)="onFilterInputChange($event, columns.CustomerRefNumber)"></app-consolidation-filter>
        </div>
        <div class="form-group col">
          <app-consolidation-filter [placeholder]="'Search Consignee Name'" (inputChange)="onFilterInputChange($event, columns.ConsigneeName)"></app-consolidation-filter>
        </div>
        <div class="form-group col">
          <app-consolidation-filter [placeholder]="'Search Shipment#'" (inputChange)="onFilterInputChange($event, columns.ShipmentCode)"></app-consolidation-filter>
        </div>
      </div>
    </div>
    <div class="col-3" style="text-align: center; margin:auto;">
      <div class="form-group col-12">
        <button type="submit" class="search" [disabled]="!isFilterChanged() || isFilterEmpty()" (click)="update()">
          <i class="material-icons" title="Search">search</i>
        </button>
      </div>
      <div class="form-group col-12">
        <button class="btn btn-link clear" (click)="clearFilters()">
          Clear Filters
        </button>
      </div>
    </div>
  </div>
</div>